import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsEditNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.24.875a1.958 1.958 0 012.77 0l2.114 2.115a1.958 1.958 0 010 2.77l-8.667 8.666a1.958 1.958 0 01-1.384.573H2.292A1.292 1.292 0 011 13.708v-2.781c0-.52.206-1.018.574-1.385zm4 4a.708.708 0 000-1.001l-2.114-2.115a.708.708 0 00-1.002 0L9.884 3 13 6.116zM2.814 10.07l2.493.623.623 2.493L12.116 7 9 3.883zm-.564 1.147v2.492c0 .023.019.041.042.041h2.49l-.506-2.026z"
        fill=""
      />
    </svg>
  )
);
SvgActionsEditNormalXsmall.defaultProps = {
  color: "currentColor",
  size: 16,
  title: undefined,
  titleId: undefined,
};
SvgActionsEditNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsEditNormalXsmall;
